import React, { useState, useEffect } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import CheckIcon from "@mui/icons-material/Check";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import axiosHttp from "../../../services/interceptor";

import "../ConfirmEmail/ConfirmEmail.scss";

const ConfirmEmail = () => {
	const [loading, setLoading] = useState(true);
	const [apiStatus, setApiStatus] = useState(null);
	const [message, setMessage] = useState("");
	const [searchParams] = useSearchParams();
	const location = useLocation();

	useEffect(() => {
		const initializeUser = async () => {
			const userId = searchParams.get("userId");
			const token = searchParams.get("token");

			if (!userId || !token) {
				setApiStatus(false);
				setMessage("Invalid parameters in the URL.");
				setLoading(false);
				return;
			}

			const transformedToken = token.replace(/ /g, "+");

			if (location.pathname === "/confirmEmail") {
				sessionStorage.setItem("header-footer", false);
				// localStorage.setItem("confirmEmail", transformedToken);
			}

			try {
				const response = await axiosHttp.post(
					`api/Accounts/ConfirmEmail`,
					{
						userId,
						token: transformedToken,
					}
				);
				setApiStatus(response.status === 200);
				setMessage(
					response.data?.message || "Email confirmed successfully!"
				);
			} catch (error) {
				setApiStatus(false);
				setMessage(
					error.response?.data?.message ||
						"An unexpected error occurred. Please try again."
				);
				console.error("Error:", error);
			} finally {
				setLoading(false);
			}
		};

		initializeUser();
	}, [searchParams,location.pathname]);

	// Icon based on API status
	const StatusIcon = apiStatus ? (
		<CheckIcon sx={{ fontSize: "50px", marginBottom: "1.2rem" }} />
	) : (
		<CancelRoundedIcon
			sx={{
				fontSize: "32px",
				marginBottom: "0.33rem",
				color: "#da1f33",
				marginLeft: "0.4rem",
			}}
		/>
	);

	return (
		<div className="d-flex justify-content-center align-items-center min-vh-100 email-container">
			{loading ? (
				<p>Loading...</p>
			) : (
				apiStatus !== null && (
					<>
						<h3
							className={`email-notification text-center ${
								apiStatus ? "" : "email-notification-error"
							}`}
						>
							{message}
						</h3>
						{StatusIcon}
					</>
				)
			)}
		</div>
	);
};

export default ConfirmEmail;
